<form [formGroup]="form">
  <input type="text" [formControlName]="fieldName" hidden="true" [name]="getName()" />
  <s-form-error-input
    [groupName]="groupName"
    [fieldName]="fieldName"
    [form]="form"
    [apiError]="apiError"
    [schema]="schema"
  />
</form>
